import { downloadBlobFromResponse, getCsrfValue } from "~/common/utils/ApiHelper";
import { getStore } from "~/app/store/getStore";
import { getSearchEndpointParams } from "~/features/search/api/fetchSearchResults";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export const downloadSalesCampaignExcel = () => {
  const apiUrl = resolveApiUrl(`/api/salescampaign/download/excel`);
  // the salesCampaign download API uses the same params used in the search call
  const searchParams = getSearchEndpointParams(getStore().getState().srp);
  const url = `${apiUrl}?${searchParams.toString()}`;

  return fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "GET",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};

export const downloadSalesCampaignCsv = () => {
  const apiUrl = resolveApiUrl(`/api/salescampaign/download/csv`);

  const searchParams = getSearchEndpointParams(getStore().getState().srp);
  const url = `${apiUrl}?${searchParams.toString()}`;

  return fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "GET",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  })
    .then(downloadBlobFromResponse)
    .catch((error) => {
      console.warn(error);
    });
};
